// ============= Imports =============
import { useMemo } from 'react';
import { Extras } from '../types';
import { FormStackProps } from '@tw/tw-component-library';

// ============= Constants =============
/**
 * Maximum number of legal PAs that can be selected
 */
const MAX_LEGAL_PA_SELECTION = 3;

// ============= Hook =============
/**
 * Custom hook to generate form configuration and schema
 * @param extras - Additional configuration and callback properties
 * @returns Object containing form schema
 */
export const useFormConfig = (extras: Extras): { formSchema: FormStackProps['formSchema'] } => {
  /**
   * Memoized form schema configuration
   */
  console.log(extras.tagPicker, "formconfig")
  const formSchema: FormStackProps['formSchema'] = useMemo(
    () => ({
      sections: [
        {
          fields: [
            {
              type: 'tagPicker',
              name: 'twlegalPA',
              label: "Legal PA's",
              placeholder: 'Search for a Legal PA',
              extras: {
                tagPicker: extras.tagPicker,
              },
              description: `Select up to ${MAX_LEGAL_PA_SELECTION} users from the list`,
              required: true,
            },
            {
              type: 'text',
              name: 'floorRoom',
              label: 'Floor / Room',
              required: true,
              placeholder: 'Enter Floor and Room',
              defaultValue: extras.defaultValues?.text?.value,
              onChange: extras.defaultValues?.text?.onChange,
            },
          ],
        },
      ],
    }),
    [extras]
  );

  return { formSchema };
};
